import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "When should I consult a gynecologic oncologist?",
    answer:
      "If you have symptoms like abnormal bleeding, pelvic pain, or suspected cancer diagnosis, early consultation is important. A specialist can provide accurate diagnosis and guide you through the best treatment options.",
  },
  {
    question: "What cancers do you treat?",
    answer:
      "Dr. Neha Agarwal specializes in treating ovarian, cervical, uterine, vaginal, and vulval cancers using advanced surgical and non-surgical techniques.",
  },
  {
    question: "Is HIPEC available in Kolkata?",
    answer:
      "Yes, advanced HIPEC (Hyperthermic Intraperitoneal Chemotherapy) surgery is available for selected cases under expert care at leading hospitals in Kolkata.",
  },
  {
    question: "Do you offer minimally invasive surgery?",
    answer:
      "Yes, laparoscopic, robotic and advanced surgical techniques are used whenever suitable to ensure faster recovery and better outcomes for patients.",
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#F2EFE9]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Left: Heading */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#8FA998] mb-4">
              Common Questions
            </p>
            <h2
              data-testid="faq-heading"
              className="font-serif text-4xl sm:text-5xl tracking-tight text-[#1E3F33] leading-tight"
            >
              Frequently Asked Questions
            </h2>
            <p className="text-base sm:text-lg text-[#4A6359] mt-4 leading-relaxed">
              Find answers to common questions about gynecologic cancer treatment, procedures, and consultations.
            </p>
          </motion.div>

          {/* Right: Accordion */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-[#D8DDD9] py-1"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="font-serif text-lg sm:text-xl text-[#1E3F33] hover:no-underline py-5 text-left"
                  >
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-[#4A6359] text-base leading-relaxed pb-5"
                  >
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
